import { useNavigate } from 'react-router-dom';

// Components
import { CardSegurosWeb } from './component/card-seguros-web.component';
import { CarrucelSegurosMobil } from './component/carrucel-seguros-mobil.component';

// Const
import { rutasCotizar } from '../../../common/constants';

const CardSeguroTitulo = () => {
  const navigate = useNavigate();

  const handleClick = (codigoSeguro, tipo) => {
    const ruta = rutasCotizar.find(ruta => ruta.codigo === codigoSeguro);

    navigate(ruta.ruta, { state: tipo });
  };

  return (
    <>
      <CardSegurosWeb handleClick={handleClick} />
      <CarrucelSegurosMobil handleClick={handleClick} />
    </>
  );
};

export default CardSeguroTitulo;
